/**
 * Presents a real ClientDesk VA product screenshot inside a subtle device frame.
 * variant: "phone" (rounded 40px) | "tablet" (rounded 24px) | "desktop" (browser chrome)
 */
export default function AppShotFrame({ src, alt, variant = "tablet", className = "" }) {
  if (variant === "desktop") {
    return (
      <figure className={`rounded-2xl overflow-hidden border border-[#E8E2D9] shadow-[0_30px_60px_-30px_rgba(26,42,58,0.25)] bg-white ${className}`}>
        <div className="flex items-center gap-1.5 px-4 py-2.5 border-b border-[#E8E2D9] bg-[#FAF7F2]">
          <span className="w-2.5 h-2.5 rounded-full bg-[#E8C4B0]" />
          <span className="w-2.5 h-2.5 rounded-full bg-[#EFD9A6]" />
          <span className="w-2.5 h-2.5 rounded-full bg-[#C7D7B8]" />
        </div>
        <img src={src} alt={alt} loading="lazy" className="w-full h-auto block" />
      </figure>
    );
  }

  const radius = variant === "phone" ? "rounded-[36px]" : "rounded-[24px]";
  const pad = variant === "phone" ? "p-1.5" : "p-2";
  return (
    <figure
      className={`${radius} ${pad} bg-[#22384F] shadow-[0_35px_70px_-30px_rgba(34,56,79,0.35)] ${className}`}
    >
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className={`${radius} block w-full h-auto`}
        style={{ borderRadius: variant === "phone" ? 32 : 20 }}
      />
    </figure>
  );
}
